import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

interface User {
    profile: {
        id: string;
        userName: string;
    };
}

interface Props {
    users: User[];
}

const Container = styled.div`
  margin-top: 20px;
`;

const Title = styled.h3`
  color: #23419a;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 20px;
`;

const UserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const UserItem = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background-color: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: fit-content;

  &:hover {
    background-color: #23419a;
    border-color: #23419a;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(35, 65, 154, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const UserName = styled.span`
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`;

const NoResults = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 16px;
`;

export const UserSearchResult: React.FC<Props> = ({ users }) => {
    const history = useHistory();

    const handleUserClick = (userId: string) => {
        // User: プレフィックスを安全に削除
        const cleanUserId = userId.startsWith('User:') 
            ? userId.substring(5) // "User:".length = 5
            : userId;
        history.push(`/dashboard/${cleanUserId}`);
    };

    return (
        <Container>
            <Title>Results ({users.length})</Title>
            {users.length === 0 ? (
                <NoResults>
                    No users found
                </NoResults>
            ) : (
                <UserList>
                    {users.map((user) => (
                        <UserItem 
                            key={user.profile.id}
                            onClick={() => handleUserClick(user.profile.id)}
                        >
                            <UserName>{user.profile.userName}</UserName>
                        </UserItem>
                    ))}
                </UserList>
            )}
        </Container>
    );
};